import Config from '../components/common/Config';
import { axiosPostEncryptedForm, joinApiUrl, postEncryptedForm, postEncryptedFormFromFormData } from './eposApi';

function resolveBearerToken(bearerToken) {
  return bearerToken || localStorage.getItem('token') || localStorage.getItem('accessToken');
}

function proformaInvoiceUrl() {
  return joinApiUrl(Config.API_URL, 'ws-proforma-invoice');
}

export async function fetchProformaInvoicePayload(plainPayload, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  const { response, data } = await postEncryptedForm(
    proformaInvoiceUrl(),
    token,
    plainPayload
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return data;
}

export async function fetchProformaInvoice(orderId, bearerToken) {
  return fetchProformaInvoicePayload({ orderId: String(orderId ?? '') }, bearerToken);
}

export async function axiosFetchProformaInvoice(orderId, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  return axiosPostEncryptedForm(proformaInvoiceUrl(), token, {
    orderId: String(orderId ?? ''),
  });
}

export async function fetchProformaInvoiceFromFormData(formData, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  const { response, data } = await postEncryptedFormFromFormData(
    proformaInvoiceUrl(),
    token,
    formData
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return data;
}
